import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Modal from "react-bootstrap/Modal";
import dsBankApi from "service/TichHopBank/dsBankApi";
import { pushNotification } from "utils/notifications";

export const ModalHuyLienKetNganHangMB = ({ toggleModal, isModalVisible, item, onSearch }) => {
  const [bDisable, setDisableButton] = useState(false);
  const [isBuocXacThuc, setIsBuocXacThuc] = useState(false);
  const [maOtp, setMaOtp] = useState("");

  const CloseModal = () => {
    setDisableButton(true);
    setIsBuocXacThuc(false);
    toggleModal();
  };
  const updateOtpValue = () => (e) => {
    setMaOtp(e.target.value);
  };
  const HuyLienKetNganHangMB = () => {
    setDisableButton(true);
    dsBankApi.huyLienKetNganHang({ idTaiKhoan: item.Id }).then((response) => {
      setDisableButton(false);
      if (response.status === 200) {
        // onSearch();
        // toggleModal();
        // pushNotification(
        //   "Thao tác thành công",
        //   "success",
        //   "TOP_CENTER",
        //   2000
        // );
        setIsBuocXacThuc(true);

      } else {
        pushNotification(
          response.data,
          "error",
          "TOP_CENTER",
          2000
        )
      }
    });
  }

  const XacThucOPT = () => {
    setDisableButton(true);
    dsBankApi.xacThucOTPHuyDangKyPushBDSD({ idTaiKhoan: item.Id, maOtp: maOtp }).then((response) => {
      setDisableButton(false);
      if (response.status === 200) {
        onSearch();
        toggleModal();
        pushNotification(
          "Thao tác thành công",
          "success",
          "TOP_CENTER",
          2000
        );
      } else {
        pushNotification(
          response.data,
          "error",
          "TOP_CENTER",
          2000
        )
      }
    });
  }
  useEffect(() => {
  }, []);
  return (
    <Modal
      show={isModalVisible}
      size="modal-lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-new modal fade text-left">
      <Modal.Header>
        <h4 className="modal-title" id="myModalLabel16">
          <span className="btn-icon-right">
            <i className="mdi mdi-pipe-disconnected" style={{color: "red"}}></i>
          </span>
          Hủy liên kết ngân hàng
        </h4>
        <button type="button" className="close-popup-new" onClick={e => CloseModal()}>
          <i className="mdi mdi-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body className="">
        <div class="body-detail-bc" style={{ color: "black" }}>
          <div class="form-money-2" style={{ marginBottom: "5px" }}>
            <div class="row">
              {isBuocXacThuc == false &&
                <div class="col-sm-12">
                  <label style={{ paddingRight: "10px" }}>
                    <span style={{ color: "black" }}>Bạn xác nhận hủy đăng ký nhận biến động số dư và lịch sử từ ngân hàng?</span>
                  </label>
                </div>
              }
              {isBuocXacThuc == true && (
                <>
                  <div class="col-sm-12">
                    <span style={{ color: "black" }}>Nhập mã OTP gửi về số điện thoại của bạn?</span>
                  </div>
                  <div class="col-sm-12" style={{ marginTop: "10px" }}>
                    <input type="text" style={{ width: "150px", textAlign: "center", marginLeft: "auto", marginRight: "auto", fontSize: "25px", height: "35px", border: "none", borderBottom: "1px dotted" }} className="form-control input-sm" value={maOtp} onChange={updateOtpValue()} />
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div class="from-button-modal">
          {isBuocXacThuc == false &&
            <div class="row">
              <div class="col-md-6"></div>
              <div class="col-md-6 text-right">
                <button className="btn btn-new-main btn-checknew" onClick={e => HuyLienKetNganHangMB()} disabled={bDisable}>
                  <span className="btn-icon-left">
                    <i className="mdi mdi-check"></i>
                  </span>
                  Hủy liên kết
                </button>
                <button
                  type="button"
                  class="btn btn-new-main btn-closenew"
                  onClick={e => CloseModal()}
                  style={{ marginLeft: "5px" }}
                >
                  <span class="btn-icon-left">
                    <i class="mdi mdi-close"></i>
                  </span>
                  Đóng
                </button>
              </div>
            </div>
          }
          {isBuocXacThuc == true &&
            <div class="row">
              <div class="col-md-6"></div>
              <div class="col-md-6 text-right">
                <button className="btn btn-new-main btn-checknew" onClick={e => XacThucOPT()} disabled={bDisable}>
                  <span className="btn-icon-left">
                    <i className="mdi mdi-check"></i>
                  </span>
                  Xác thực
                </button>
                <button
                  type="button"
                  class="btn btn-new-main btn-closenew"
                  onClick={e => CloseModal()}
                  style={{ marginLeft: "5px" }}
                >
                  <span class="btn-icon-left">
                    <i class="mdi mdi-close"></i>
                  </span>
                  Đóng
                </button>
              </div>
            </div>
          }
        </div>
      </Modal.Footer>
    </Modal>
  );
};
